export default __webpack_public_path__ + "static/media/Shampoo_SLEEK_MOIST_250_P.a3fd3549.png";